import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form';
import * as validate from './FormValidation';
import {scrollToFirstError} from '../helpers/ReduxFormScrollToError';
import { Button, Icon, Divider, Alert } from 'antd';


const ButtonGroup = Button.Group;


const FormGrundAnzusch = props => {
    const { handleSubmit, pristine, reset, submitting, back } = props;

    const welchesGebaudeSelected = props.Ans_Einfamilienhaus || props.Ans_Mehrfamilienhaus || props.AnsGarageValue || props.AnsStallValue || props.AnsSonstigesValue;

    return (
        <form onSubmit={handleSubmit}>
            <div className="content">
                <Divider orientation={"left"}>Anzuschließendes Grundstück</Divider>


                <Field
                    name="Ans_Strasse"
                    label="Straße & Hausnummer:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                />

                <Field
                    name="Ans_PLZ"
                    label="PLZ:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.number]}
                />

                <Field
                    name="Ans_Ort"
                    label="Ort:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                />

                <Field
                    name="Ans_Bez_Baugeb"
                    label="Bezeichnung d. Baugebiets (Bebauungsplan):"
                    type="text"
                    component={validate.renderField}
                    
                />

                <Field
                    name="Ans_Gemarkung"
                    label="Gemarkung:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                />

                <Field
                    name="Ans_Fl_Nr"
                    label="Fl.Nr.:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={[validate.required, validate.minLength2]}
                />

                <Field
                    name="Ans_Grund_Groesse"
                    label="Grundstücksgröße in m²:"
                    type="text"
                    component={validate.renderField}
                    validate={[validate.number]}
                    
                />

                <Field
                    name="Ans_Baubeginn"
                    label="Baubeginn:"
                    type="text"
                    required
                    component={validate.renderField}
                    validate={validate.required}
                />


                {/*<Field
                    name="Ans_Vermessen"
                    label="Wurde / Wird das Grundstück neu vermessen?*:"
                    type="text"
                    component={validate.renderCheckbox}
                    /*validate={validate.required}* /
                />*/}

                <Field
                    name="Ans_Vermessen"
                    label="Wurde / Wird das Grundstück neu vermessen?:"
                    component={validate.renderSelectField}
                    options={[
                        {
                            "ID": 1,
                            "Name": "Wird neu vermessen"
                        },
                        {
                            "ID": 2,
                            "Name": "Wurde neu vermessen"
                        },
                        {
                            "ID": 0,
                            "Name": "Nein"
                        }]}
                    required
                    validate={validate.requiredWithZero}
                />


                <Field
                    name="Ans_Abgebrochen"
                    label="Wurde / Wird ein Gebäude oder Gebäudeteil abgebrochen?"
                    component={validate.renderSelectField}
                    options={[
                        {
                            "ID": 1,
                            "Name": "Wird abgebrochen"
                        },
                        {
                            "ID": 2,
                            "Name": "Wurde abgebrochen"
                        },
                        {
                            "ID": 0,
                            "Name": "Nein"
                        }]}
                    required
                    validate={validate.requiredWithZero}
                    onCH={(value) => {console.log(value);}}
                />

                {(props.AnsAbgebrochenValue === 1 || props.AnsAbgebrochenValue === 2) &&
                <Field
                    name="Ans_Abbruchtermin"
                    label="Abbruchtermin:"
                    type="text"
                    component={validate.renderField}
                />
                }

                {/*<Field
                    name="Ans_Regenwasser"
                    label="Ist der Bau einer Regenwassernutzungsanlage beabsichtigt?*:"
                    type="text"
                    component={validate.renderCheckbox}
                />*/}

                <Field
                name="Ans_Regenwasser"
                label="Ist der Bau einer Regenwassernutzungsanlage beabsichtigt?"
                component={validate.renderRadioField}
                required
                validate={validate.requiredWithZero}
                options={[
                    {
                        "ID": 1,
                        "Name": "Ja"
                    },
                    {
                        "ID": 0,
                        "Name": "Nein"
                    }]}
                required
                />




                {/*<Field
                    name="Ans_Abgebrochen"
                    label="Wurde / Wird ein Gebäude oder Gebäudeteil abgebrochen?*:"
                    type="text"
                    component={validate.renderCheckbox}
                />*/}



<br/>
                <label style={{color: "rgba(0, 0, 0, 0.85)"}}><span style={{color: "red"}}>*&nbsp;</span>Welche Gebäude werden an die Trinkwasserversorgung angeschlossen?</label>

                <br/><br/>
                <Field
                    name="Ans_Einfamilienhaus"
                    label="Einfamilienhaus"
                    validate={(!welchesGebaudeSelected ? validate.required : null)}
                    component={validate.renderCheckbox}
                />

                <Field
                    name="Ans_Mehrfamilienhaus"
                    label="Mehrfamilienhaus"
                    validate={(!welchesGebaudeSelected ? validate.required : null)}
                    component={validate.renderCheckbox}
                />

                <Field
                    name="Ans_Garage"
                    label="Garage"
                    validate={(!welchesGebaudeSelected ? validate.required : null)}
                    component={validate.renderCheckbox}
                />

                <Field
                    name="Ans_Stall"
                    label="Stall"
                    validate={(!welchesGebaudeSelected ? validate.required : null)}
                    component={validate.renderCheckbox}
                />

                <Field
                    name="Ans_Sonstiges"
                    label="Sonstiges:"
                    validate={(!welchesGebaudeSelected ? validate.required : null)}
                    component={validate.renderField}
                />

                <div className={"right-container"}>
                    <Button className={"pull-right"} type={"primary"} htmlType={"submit"} disabled={submitting}>Weiter <Icon type={"right"}/></Button>
                    <Button type={"default"} htmlType={"button"} onClick={back}><Icon type={"left"}/> Zurück</Button>
                </div>


            </div>
        </form>
    );
};



let FormGrundAnzuschRedux = reduxForm({
    form: 'auftragform',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onSubmitFail: (errors) => scrollToFirstError(errors),
})(FormGrundAnzusch);

const selector = formValueSelector('auftragform');
const FormGrundAnzuschReduxConnected = connect(
    state => {

        const AnsAbgebrochenValue = selector(state, 'Ans_Abgebrochen');
        const Ans_Einfamilienhaus = selector(state, 'Ans_Einfamilienhaus');
        const Ans_Mehrfamilienhaus = selector(state, 'Ans_Mehrfamilienhaus');
        const AnsGarageValue = selector(state, 'Ans_Garage');
        const AnsStallValue = selector(state, 'Ans_Stall');
        const AnsSonstigesValue = selector(state, 'Ans_Sonstiges');

        return {
            AnsAbgebrochenValue,
            Ans_Einfamilienhaus,
            Ans_Mehrfamilienhaus,
            AnsGarageValue,
            AnsStallValue,
            AnsSonstigesValue
        }
    }
)(FormGrundAnzuschRedux);
export default FormGrundAnzuschReduxConnected;



// WEBPACK FOOTER //
// ./src/components/FormGrundAnzusch.js